/* eslint no-underscore-dangle: 0 */

import React, { useEffect, useState } from 'react';
import {
  Alert, Card, Col, Row, Table, Modal, Button,
} from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import SkillResource from '../../common/resource/SkillResource';
import { LoadingAnimation } from '../../common/components/Utilities';
import UserIcon from '../../common/components/UserIcon';

function EndorseUserPanel({ skillSet, endorseUserPanelOnChange }) {
  if (skillSet.length) {
    return null;
  }

  return (
    <Card
      className="mb-4 secondary"
      border="primary"
      style={{
        position: 'sticky',
        top: '10px',
        bottom: '10px',
        maxHeight: '100vh',
        // overflowY: 'auto',
      }}
    >
      <Card.Header>Endorse User</Card.Header>
      <Card.Body>
        <p className="mb-2">Select a user to endorse with new skills.</p>
        <div className="form-group">
          <select className="form-control" onChange={endorseUserPanelOnChange}>
            <option value="">Select a User</option>
            {window.props.allUsers.map((item) => (
              <option key={item.id} value={item.id}>{item.name}</option>
            ))}
          </select>
        </div>
      </Card.Body>
    </Card>
  );
}

function SkillTypeSelect({
  skillCreateId,
  loadingTypeSelect, skillTypeSelectData, loadSkillTypeData, setSkillCreateType, skillCreateType,
}) {
  if (skillCreateId) {
    return null;
  }
  if (!skillTypeSelectData.length && !loadingTypeSelect) {
    loadSkillTypeData();
  }
  return (
    <div className="form-group">
      <select className="form-control" name="type" disabled={loadingTypeSelect} required onChange={(event) => setSkillCreateType(parseInt(event.target.value, 10))} value={skillCreateType}>
        <option value="">Select a Type</option>
        {skillTypeSelectData.map((item) => (
          <option key={item.value} value={item.value}>{item.title}</option>
        ))}
      </select>
    </div>
  );
}

function TopFive({ skillSetUsers }) {
  return (
    <Card className="mt-4">
      <Card.Header>
        Top #5
      </Card.Header>
      <Card.Body>
        <Table borderless>
          <tbody>
            {skillSetUsers.map((userSkill) => userSkill && userSkill.user && (
              <tr key={userSkill.user.id}>
                <td>
                  <a href={`/users/${userSkill.user.id}/skills`} style={{ position: 'relative' }}>
                    <UserIcon user={userSkill.user} size={40} style={{ verticalAlign: 'top' }} round />
                    <span className="user-icon-ball">{userSkill.pivot_count}</span>
                  </a>
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  <a href={`/users/${userSkill.user.id}/skills`}><strong>{userSkill.user.name}</strong></a>
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  Latest:
                  {' '}
                  {moment(userSkill.pivot_latest).format('D MMMM YYYY')}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

function SelectedSkills({ skillSet, removeFromSkillSet }) {
  let content = (
    <Card.Body>
      <Alert variant="info">Select a skill on the left to start.</Alert>
    </Card.Body>
  );

  if (skillSet.length) {
    content = (
      <Table borderless>
        <tbody>
          {skillSet.map((skill) => (
            <tr key={skill.id}>
              <td>
                <div className={`endorsement skill-${skill.type}`}>
                  {skill.title}
                  <button
                    type="button"
                    className="skill-remove-button"
                    title="Remove this from your skillset group"
                    onClick={(event) => removeFromSkillSet(event, skill.id)}
                  >
                    -
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
  return (
    <Card className="mt-4">
      <Card.Header>
        Selected Skills
      </Card.Header>

      {content}
    </Card>
  );
}

function SkillSet({
  loadingSkillSet, skillSetUsers, skillSet, removeFromSkillSet,
}) {
  return (
    <Card
      className="mb-4 secondary"
      border="primary"
    >
      <Card.Header>Skill Set</Card.Header>
      <LoadingAnimation loading={loadingSkillSet} />
      <Card.Body>
        The top users for a combined set of skills. Add or remove skills from the list.
        <SelectedSkills skillSet={skillSet} removeFromSkillSet={removeFromSkillSet} />
        {skillSetUsers.length && <TopFive skillSetUsers={skillSetUsers} />}
      </Card.Body>
    </Card>
  );
}

function Skills({ activeUser, groups }) {
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState([]);
  const [skillSet, setSkillSet] = useState([]);
  const [loadingSkillSet, setLoadingSkillSet] = useState(false);
  const [skillSetUsers, setSkillSetUsers] = useState([]);
  const [modalShowCreate, setShowCreateModal] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingTypeSelect, setLoadingTypeSelect] = useState(false);
  const [skillCreateTitle, setSkillCreateTitle] = useState('');
  const [skillCreateId, setSkillCreateId] = useState(0);
  const [skillCreateType, setSkillCreateType] = useState('');
  const [skillTypeSelectData, setSkillTypeSelectData] = useState([]);
  const activeUserIsTeamLead = activeUser.isInGroup(groups.TEAM_LEADS);

  const loadSkills = async () => {
    setLoading(true);
    const data = await SkillResource.index({
      'with-users': true,
    });
    setSkills(data);
    setLoading(false);
  };

  useEffect(() => { loadSkills(); }, []);

  const getTotalPivotCount = (userSkills) => {
    let total = 0;
    userSkills.forEach((userSkill) => {
      total += userSkill.pivot_count;
    });
    return total;
  };

  const getSortSkillsVote = (sortedSkills, inputValue) => {
    const sortOrient = inputValue === 'skill_sort_vote_asc' ? [-1, 1] : [1, -1];
    return sortedSkills.sort((a, b) => {
      const voteA = getTotalPivotCount(a.user_skills_with_count);
      const voteB = getTotalPivotCount(b.user_skills_with_count);
      if (voteA < voteB) {
        return sortOrient[0];
      }
      if (voteA > voteB) {
        return sortOrient[1];
      }
      return 0;
    }).slice();
  };

  const getSortSkillsTitle = (sortedSkills, inputValue) => {
    const sortOrient = inputValue === 'skill_sort_title_az' ? [-1, 1] : [1, -1];
    return sortedSkills.sort((a, b) => {
      const titleA = a.title.toLowerCase();
      const titleB = b.title.toLowerCase();
      if (titleA < titleB) {
        return sortOrient[0];
      }
      if (titleA > titleB) {
        return sortOrient[1];
      }
      return 0;
    }).slice();
  };

  const sortSkillsTitle = (event) => {
    setSkills(getSortSkillsTitle(skills, event.target.value));
  };

  const sortSkillsVote = (event) => {
    setSkills(getSortSkillsVote(skills, event.target.value));
  };

  const calculateSkillSetUsers = (newSkillSet) => {
    const newUsers = newSkillSet.reduce((carry, skill) => {
      skill.user_skills_with_count.forEach((userSkill) => {
        if (userSkill.user) {
          const existing = carry.find(
            (existingUserSkill) => existingUserSkill.user.id === userSkill.user.id,
          );
          if (existing) {
            existing.pivot_count += userSkill.pivot_count;
            existing.pivot_latest = existing.pivot_latest > userSkill.pivot_latest
              ? existing.pivot_latest
              : userSkill.pivot_latest;
            carry.filter(
              (existingUserSkill) => existingUserSkill.user.id === userSkill.user.id,
            ).push(existing);
          } else {
            carry.push({ ...userSkill });
          }
        }
      });
      return carry;
    }, []);
    newUsers.sort(
      (firstUserSkill, secondUserSkill) => (firstUserSkill.pivot_count < secondUserSkill.pivot_count
        ? 1
        : -1
      ),
    );

    setSkillSetUsers(newUsers.slice(0, 5));
  };

  const addToSkillSet = async (event, id) => {
    event.preventDefault();

    setLoadingSkillSet(true);
    const data = await SkillResource.get(id, {
      'with-users': true,
    });
    setLoadingSkillSet(false);

    const newSkillSet = skillSet.filter((skill) => skill.id !== id);
    newSkillSet.push(data);
    setSkillSet(newSkillSet);
    calculateSkillSetUsers(newSkillSet);
  };

  const removeFromSkillSet = async (event, id) => {
    event.preventDefault();

    const newSkillSet = skillSet.filter((skill) => skill.id !== id);
    setSkillSet(newSkillSet);
    calculateSkillSetUsers(newSkillSet);
  };

  const handleCreateSubmit = async (event) => {
    event.preventDefault();
    setLoadingCreate(true);
    const data = {
      title: event.target.elements.title.value,
      id: event.target.elements.skill_id.value,
      _token: event.target.elements._token.value,
    };
    if (typeof event.target.elements.type !== 'undefined') {
      data.type = event.target.elements.type.value;
    }
    const response = await SkillResource.post(data);
    setLoadingCreate(false);
    if (response) {
      setShowCreateModal(false);
    } else {
      // show error msg?
    }
    loadSkills();
  };

  const endorseUserPanelOnChange = (event) => {
    window.location = `/users/${event.target.value}/skills`;
  };

  const skillTitleClick = (event) => {
    setSkillCreateTitle(event.target.innerText);
    setSkillCreateId(
      parseInt(event.target.parentElement.parentElement.parentElement.dataset.id, 10),
    );
    setShowCreateModal(true);
  };

  const loadSkillTypeData = async () => {
    setLoadingTypeSelect(true);
    try {
      const response = await axios.get('resource/skills/types');
      setSkillTypeSelectData(response.data);
    } catch (error) {
      console.error(error);
    }
    setLoadingTypeSelect(false);
  };

  const selectStyle = {
    display: 'inline-block',
    width: '140px',
    marginLeft: '1em',
  };

  const onChangeSkillTitle = (event) => {
    setSkillCreateTitle(event.target.value);
  };

  const clickCreateSkill = () => {
    setShowCreateModal(true);
    setSkillCreateTitle('');
    setSkillCreateId(0);
  };

  const hideCreateModal = () => {
    setShowCreateModal(false);
    setLoadingCreate(false);
    setSkillCreateType('');
  };

  return (
    <Row>
      <Col md={8}>
        <Card className="mb-4" style={{ minHeight: 300 }}>
          <Card.Header>
            Skills
            <div className="float-right">
              <select style={selectStyle} className="form-control" name="sort_order" onChange={sortSkillsTitle}>
                <option value="skill_sort_title_az">Skill A-Z</option>
                <option value="">Skill Z-A</option>
              </select>
              <select style={selectStyle} className="form-control" name="sort_vote" onChange={sortSkillsVote}>
                <option value="skill_sort_vote_desc">Most Votes</option>
                <option value="skill_sort_vote_asc">Least Votes</option>
              </select>

              {activeUserIsTeamLead ? <Button className="btn btn-success ml-3" onClick={clickCreateSkill}>Create Skill</Button> : ''}

            </div>
          </Card.Header>

          <Modal show={modalShowCreate} onHide={hideCreateModal}>
            <Modal.Header closeButton>
              {skillCreateId ? 'Edit' : 'Create'}
              {' '}
              Skill
            </Modal.Header>
            <LoadingAnimation loading={loadingCreate} />
            <form onSubmit={handleCreateSubmit}>
              <input type="hidden" name="_token" value={window.props.csrfToken} />
              <input type="hidden" name="skill_id" value={skillCreateId} />
              <Modal.Body>
                <SkillTypeSelect
                  skillCreateId={skillCreateId}
                  loadingTypeSelect={loadingTypeSelect}
                  skillTypeSelectData={skillTypeSelectData}
                  loadSkillTypeData={loadSkillTypeData}
                  setSkillCreateType={setSkillCreateType}
                  skillCreateType={skillCreateType}
                />
                <div className="form-group">
                  <label htmlFor="title">Title</label>
                  <input id="title" name="title" className="form-control" type="text" value={skillCreateTitle} onChange={onChangeSkillTitle} required />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit" className="btn btn-success">{skillCreateId ? 'Update' : 'Create'}</Button>
              </Modal.Footer>
            </form>
          </Modal>

          <LoadingAnimation loading={loading} />

          <Table>
            <thead>
              { skills.length > 0 && (
                <tr>
                  <th />
                  <th>🎓🎓🎓</th>
                  <th>🎓🎓</th>
                  <th>🎓</th>
                </tr>
              )}
            </thead>
            <tbody>
              {
              skills.map((skill) => (
                <tr key={skill.id} data-id={skill.id}>
                  <td style={{ verticalAlign: 'middle' }}>
                    <div className={`endorsement skill-${skill.type}`}>

                      {(() => {
                        if (activeUserIsTeamLead) {
                          return <button type="button" onClick={skillTitleClick} style={{ cursor: 'pointer', border: 'none', padding: 0 }} title="Edit skill">{skill.title}</button>;
                        }
                        return <span style={{ border: 'none', padding: 0 }}>{skill.title}</span>;
                      })()}

                      {skillSet.find((skillSetItem) => skillSetItem.id === skill.id) !== undefined
                        ? (
                          <button
                            type="button"
                            className="skill-remove-button"
                            title="Remove this from your skillset group"
                            onClick={(event) => removeFromSkillSet(event, skill.id)}
                          >
                            -
                          </button>
                        )
                        : (
                          <button
                            type="button"
                            className="skill-add-button"
                            title="Add this to your skillset group"
                            onClick={(event) => addToSkillSet(event, skill.id)}
                          >
                            +
                          </button>
                        )}
                    </div>
                  </td>
                  {[0, 1, 2].map((key) => {
                    const userSkill = skill.user_skills_with_count[key];
                    return userSkill && userSkill.user ? (
                      <td key={key} style={{ paddingBottom: '1rem' }}>
                        <a href={`/users/${userSkill.user.id}/skills`} style={{ position: 'relative' }}>
                          <UserIcon user={userSkill.user} size={40} style={{ verticalAlign: 'top' }} round />
                          <span className="user-icon-ball">{userSkill.pivot_count}</span>
                        </a>
                      </td>
                    ) : <td key={key} />;
                  })}
                </tr>
              ))
            }
            </tbody>
          </Table>
        </Card>
      </Col>
      <Col md={4}>
        <div style={{
          position: 'sticky',
          top: '10px',
          bottom: '10px',
          maxHeight: '100vh',
          overflowY: 'auto',
        }}
        >
          <SkillSet
            skillSet={skillSet}
            removeFromSkillSet={removeFromSkillSet}
            loadingSkillSet={loadingSkillSet}
            skillSetUsers={skillSetUsers}
          />
          <EndorseUserPanel
            skillSet={skillSet}
            endorseUserPanelOnChange={endorseUserPanelOnChange}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Skills;
